// console.log("frontpage-headerslider");

import Flickity from "flickity";
// import Flickity from "flickity-fade";

document.addEventListener("DOMContentLoaded", function () {
  var frontpageslider = document.querySelector(".frontpageslider");

  // if (frontpageslider) {
  //   var flkty = new Flickity(frontpageslider, {
  //     // fade: true,
  //     lazyLoad: true,
  //     adaptiveHeight: true,
  //     prevNextButtons: true,
  //     pageDots: false,
  //     wrapAround: true,
  //     // fullscreen: true,
  //   });
  // }

  if (frontpageslider) {
    var flkty = new Flickity(frontpageslider, {
      lazyLoad: false,
      adaptiveHeight: true,
      prevNextButtons: true,
      pageDots: false,
      wrapAround: true,
    });
    frontpageslider.classList.add("pageloaded");
  }
});
